export const esConjugations = [
    {
        i: 'estar',
        'present': ['estoy', 'estás', 'está', 'estamos', 'estáis', 'están'],
        'imperfect': ['estaba', 'estabas', 'estaba', 'estábamos', 'estabais', 'estaban'],
        'preterite': ['estuve', 'estuviste', 'estuvo', 'estuvimos', 'estuvisteis', 'estuvieron'],
        'future': ['estaré', 'estarás', 'estará', 'estaremos', 'estaréis', 'estarán'],
        conditional: ['estaría','estarías','estaría','estaríamos','estaríais','estarían'],
        'past perfect': ['he estado', 'has estado', 'ha estado', 'hemos estado', 'habéis estado', 'han estado'],
        'pluperfect': ['había estado', 'habías estado', 'había estado', 'habíamos estado', 'habíais estado', 'habían estado'],
        'future perfect': ['habré estado', 'habrás estado', 'habrá estado', 'habremos estado', 'habréis estado', 'habrán estado'],
        'past anterior': ['hube estado', 'hubiste estado', 'hubo estado', 'hubimos estado', 'hubisteis estado', 'hubieron estado'],
        'present subjunctive':['esté','estés','esté','estemos','estéis','estén'],
        'imperfect subjunctive':['estuviera','estuvieras','estuviera','estuviéramos','estuvierais','estuvieran'],
        // 'future subjunctive'
        'perfect subjunctive':['haya estado','hayas estado','haya estado','hayamos estado','hayáis estado','hayan estado'],
        'pluperfect subjunctive':['hubiera estado','hubieras estado','hubiera estado','hubiéramos estado','hubierais estado','hubieran estado'],
        // 'future perfect subjunctive'
        gerund: 'estando',
        participle: 'estado'
    },
    {
        i: 'ser',
        'present': ['soy', 'eres', 'es', 'somos', 'sois', 'son'],
        'imperfect': ['era', 'eras', 'era', 'éramos', 'erais', 'eran'],
        'future': ['seré', 'serás', 'será', 'seremos', 'seréis', 'serán'],
        'preterite': ['fui', 'fuiste', 'fue', 'fuimos', 'fuisteis', 'fueron'],
        'past perfect': ['he sido', 'has sido', 'ha sido', 'hemos sido', 'habéis sido', 'han sido'],
        'pluperfect': ['había sido', 'habías sido', 'había sido', 'habíamos sido', 'habíais sido', 'habían sido'],
        'future perfect': ['habré sido', 'habrás sido', 'habrá sido', 'habremos sido', 'habréis sido', 'habrán sido'],
        'past anterior': ['hube sido', 'hubiste sido', 'hubo sido', 'hubimos sido', 'hubisteis sido', 'hubieron sido'],
        conditional: ['sería','serías','sería','seríamos','seríais','serían'],
        'present subjunctive': ['sea', 'seas', 'sea', 'seamos', 'seáis', 'sean'],
        'imperfect subjunctive': ['fuera', 'fuerass', 'fuera', 'fuéramos', 'fuerais', 'fueran'],
        'perfect subjunctive': ['haya sido', 'hayas sido', 'haya sido', 'hayamos sido', 'hayáis sido', 'hayan sido'],
        'pluperfect subjunctive': ['hubiera sido', 'hubierass sido', 'hubiera sido', 'hubiéramos sido', 'hubierais sido', 'hubieran sido'],
        gerund: 'siendo',
        participle: 'sido'
    },
    {
        i: 'dar',        
        'present': ['doy', 'das', 'da', 'damos', 'dais', 'dan'],
        'imperfect': ['daba', 'dabas', 'daba', 'dábamos', 'dabais', 'daban'],
        'future': ['daré', 'darás', 'dará', 'daremos', 'daréis', 'darán'],
        'preterite': ['di', 'diste', 'dio', 'dimos', 'disteis', 'dieron'],
        'past perfect': ['he dado', 'has dado', 'ha dado', 'hemos dado', 'habéis dado', 'han dado'],
        'pluperfect': ['había dado', 'habías dado', 'había dado', 'habíamos dado', 'habíais dado', 'habían dado'],
        'future perfect': ['habré dado', 'habrás dado', 'habrá dado', 'habremos dado', 'habréis dado', 'habrán dado'],
        'past anterior': ['hube dado', 'hubiste dado', 'hubo dado', 'hubimos dado', 'hubisteis dado', 'hubieron dado'],
        conditional: ['daría','darías','daría','daríamos','daríais','darían'],
        'present subjunctive': ['dé', 'des', 'dé', 'demos', 'deis', 'den'],
        'imperfect subjunctive': ['diera', 'dierass', 'diera', 'diéramos', 'dierais', 'dieran'],
        'perfect subjunctive': ['haya dado', 'hayas dado', 'haya dado', 'hayamos dado', 'hayáis dado', 'hayan dado'],
        'pluperfect subjunctive': ['hubiera dado', 'hubierass dado', 'hubiera dado', 'hubiéramos dado', 'hubierais dado', 'hubieran dado'],
        gerund: 'dando',
        participle: 'dado'
    },
    {
        i: 'hacer',
        'present': ['hago', 'haces', 'hace', 'hacemos', 'hacéis', 'hacen'],
        'imperfect': ['hacía', 'hacías', 'hacía', 'hacíamos', 'hacíais', 'hacían'],
        'future': ['haré', 'harás', 'hará', 'haremos', 'haréis', 'harán'],
        'preterite': ['hice', 'hiciste', 'hizo', 'hicimos', 'hicisteis', 'hicieron'],
        'past perfect': ['he hecho', 'has hecho', 'ha hecho', 'hemos hecho', 'habéis hecho', 'han hecho'],
        'pluperfect': ['había hecho', 'habías hecho', 'había hecho', 'habíamos hecho', 'habíais hecho', 'habían hecho'],
        'future perfect': ['habré hecho', 'habrás hecho', 'habrá hecho', 'habremos hecho', 'habréis hecho', 'habrán hecho'],
        'past anterior': ['hube hecho', 'hubiste hecho', 'hubo hecho', 'hubimos hecho', 'hubisteis hecho', 'hubieron hecho'],
        conditional: ['haría','harías','haría','haríamos','haríasi','harían'],
        'present subjunctive': ['haga', 'hagas', 'haga', 'hagamos', 'hagáis', 'hagan'],
        'imperfect subjunctive': ['hiciera', 'hicieras', 'hiciera', 'hiciéramos', 'hicierais', 'hicieran'],
        'perfect subjunctive': ['haya hecho', 'hayas hecho', 'haya hecho', 'hayamos hecho', 'hayáis hecho', 'hayan hecho'],
        'pluperfect subjunctive': ['hubiera hecho', 'hubierass hecho', 'hubiera hecho', 'hubiéramos hecho', 'hubierais hecho', 'hubieran hecho'],
        gerund: 'haciendo',
        participle: 'hecho'
    },
    {
        i: 'ir',
        'present': ['voy', 'vas', 'va', 'vamos', 'vais', 'van'],
        'imperfect': ['iba', 'ibas', 'iba', 'íbamos', 'ibais', 'iban'],
        'future': ['iré', 'irás', 'irá', 'iremos', 'iréis', 'irán'],
        'preterite': ['fui', 'fuiste', 'fue', 'fuimos', 'fuisteis', 'fueron'],
        'past perfect': ['he ido', 'has ido', 'ha ido', 'hemos ido', 'habéis ido', 'han ido'],
        'pluperfect': ['había ido', 'habías ido', 'había ido', 'habíamos ido', 'habíais ido', 'habían ido'],
        'future perfect': ['habré ido', 'habrás ido', 'habrá ido', 'habremos ido', 'habréis ido', 'habrán ido'],
        'past anterior': ['hube ido', 'hubiste ido', 'hubo ido', 'hubimos ido', 'hubisteis ido', 'hubieron ido'],
        conditional: ['iría','irías','iría','iríamos','iríais','irían'],
        'present subjunctive': ['vaya', 'vayas', 'vaya', 'vayamos', 'vayáis', 'vayan'],
        'imperfect subjunctive': ['fuera', 'fuerass', 'fuera', 'fuéramos', 'fuerais', 'fueran'],
        'perfect subjunctive': ['haya ido', 'hayas ido', 'haya ido', 'hayamos ido', 'hayáis ido', 'hayan ido'],
        'pluperfect subjunctive': ['hubiera ido', 'hubierass ido', 'hubiera ido', 'hubiéramos ido', 'hubierais ido', 'hubieran ido'],
        gerund: 'yendo',
        participle: 'ido'
    },
    {
        i: 'decir',
        'present': ['digo', 'dices', 'dice', 'decimos', 'decís', 'dicen'],
        'imperfect': ['decía', 'decías', 'decía', 'decíamos', 'decíais', 'decían'],
        'future': ['diré', 'dirás', 'dirá', 'diremos', 'diréis', 'dirán'],
        'preterite': ['dije', 'dijiste', 'dijo', 'dijimos', 'dijisteis', 'dijeron'],
        'past perfect': ['he dicho', 'has dicho', 'ha dicho', 'hemos dicho', 'habéis dicho', 'han dicho'],
        'pluperfect': ['había dicho', 'habías dicho', 'había dicho', 'habíamos dicho', 'habíais dicho', 'habían dicho'],
        'future perfect': ['habré dicho', 'habrás dicho', 'habrá dicho', 'habremos dicho', 'habréis dicho', 'habrán dicho'],
        'past anterior': ['hube dicho', 'hubiste dicho', 'hubo dicho', 'hubimos dicho', 'hubisteis dicho', 'hubieron dicho'],
        conditional: ['diría','dirías','diría','diríamos','diríais','dirían'],
        'present subjunctive': ['diga', 'digas', 'diga', 'digamos', 'digáis', 'digan'],
        'imperfect subjunctive': ['dijera', 'dijeras', 'dijera', 'dijéramos', 'dijerais', 'dijeran'],
        'perfect subjunctive': ['haya dicho', 'hayas dicho', 'haya dicho', 'hayamos dicho', 'hayáis dicho', 'hayan dicho'],
        'pluperfect subjunctive': ['hubiera dicho', 'hubierass dicho', 'hubiera dicho', 'hubiéramos dicho', 'hubierais dicho', 'hubieran dicho'],
        gerund: 'diciendo',
        participle: 'dicho'
    },
    {
        i: 'leer',
        'present': ['leo', 'lees', 'lee', 'leemos', 'leéis', 'leen'],
        'imperfect': ['leía', 'leías', 'leía', 'leíamos', 'leíais', 'leían'],
        'future': ['leeré', 'leerás', 'leerá', 'leeremos', 'leeréis', 'leerán'],
        'preterite': ['leí', 'leíste', 'leyó', 'leímos', 'leísteis', 'leyeron'],
        'past perfect': ['he leído', 'has leído', 'ha leído', 'hemos leído', 'habéis leído', 'han leído'],
        'pluperfect': ['había leído', 'habías leído', 'había leído', 'habíamos leído', 'habíais leído', 'habían leído'],
        'future perfect': ['habré leído', 'habrás leído', 'habrá leído', 'habremos leído', 'habréis leído', 'habrán leído'],
        'past anterior': ['hube leído', 'hubiste leído', 'hubo leído', 'hubimos leído', 'hubisteis leído', 'hubieron leído'],
        conditional: ['leería','leerías','leería','leeríamos','leeríais','leerían'],
        'present subjunctive': ['lea', 'leas', 'lea', 'leamos', 'leáis', 'lean'],
        'imperfect subjunctive': ['leyera', 'leyeras', 'leyera', 'leyéramos', 'leyerais', 'leyeran'],
        'perfect subjunctive': ['haya leído', 'hayas leído', 'haya leído', 'hayamos leído', 'hayáis leído', 'hayan leído'],
        'pluperfect subjunctive': ['hubiera leído', 'hubierass leído', 'hubiera leído', 'hubiéramos leído', 'hubierais leído', 'hubieran leído']
    },
    {
        i: 'llegar',
        'present': ['llego', 'llegas', 'llega', 'llegamos', 'llegáis', 'llegan'],
        'imperfect': ['llegaba', 'llegabas', 'llegaba', 'llegábamos', 'llegabais', 'llegaban'],
        'future': ['llegaré', 'llegarás', 'llegará', 'llegaremos', 'llegaréis', 'llegarán'],
        'preterite': ['llegué', 'llegaste', 'llegó', 'llegamos', 'llegasteis', 'llegaron'],
        'past perfect': ['he llegado', 'has llegado', 'ha llegado', 'hemos llegado', 'habéis llegado', 'han llegado'],
        'pluperfect': ['había llegado', 'habías llegado', 'había llegado', 'habíamos llegado', 'habíais llegado', 'habían llegado'],
        'future perfect': ['habré llegado', 'habrás llegado', 'habrá llegado', 'habremos llegado', 'habréis llegado', 'habrán llegado'],
        'past anterior': ['hube llegado', 'hubiste llegado', 'hubo llegado', 'hubimos llegado', 'hubisteis llegado', 'hubieron llegado'],
        conditional: ['llegaría','llegarías','llegaría','llegaríamos','llegaríais','llegarían'],
        'present subjunctive': ['llegue', 'llegues', 'llegue', 'lleguemos', 'lleguéis', 'lleguen'],
        'imperfect subjunctive': ['llegara', 'llegaras', 'llegara', 'llegáramos', 'llegarais', 'llegaran'],
        'perfect subjunctive': ['haya llegado', 'hayas llegado', 'haya llegado', 'hayamos llegado', 'hayáis llegado', 'hayan llegado'],
        'pluperfect subjunctive': ['hubiera llegado', 'hubierass llegado', 'hubiera llegado', 'hubiéramos llegado', 'hubierais llegado', 'hubieran llegado'],
        gerund: 'llegando',
        participle: 'llegado'
    },
    {
        i: 'oír',
        'present': ['oigo', 'oyes', 'oye', 'oímos', 'oís', 'oyen'],
        'imperfect': ['oía', 'oías', 'oía', 'oíamos', 'oíais', 'oían'],
        'future': ['oiré', 'oirás', 'oirá', 'oiremos', 'oiréis', 'oirán'],
        'preterite': ['oí', 'oíste', 'oyó', 'oímos', 'oísteis', 'oyeron'],
        'past perfect': ['he oído', 'has oído', 'ha oído', 'hemos oído', 'habéis oído', 'han oído'],
        'pluperfect': ['había oído', 'habías oído', 'había oído', 'habíamos oído', 'habíais oído', 'habían oído'],
        'future perfect': ['habré oído', 'habrás oído', 'habrá oído', 'habremos oído', 'habréis oído', 'habrán oído'],
        'past anterior': ['hube oído', 'hubiste oído', 'hubo oído', 'hubimos oído', 'hubisteis oído', 'hubieron oído'],
        conditional: ['oiría','oirías','oiría','oiríamos','oiríais','oirían'],
        'present subjunctive': ['oiga', 'oigas', 'oiga', 'oigamos', 'oigáis', 'oigan'],
        'imperfect subjunctive': ['oyera', 'oyeras', 'oyera', 'oyéramos', 'oyerais', 'oyeran'],
        'perfect subjunctive': ['haya oído', 'hayas oído', 'haya oído', 'hayamos oído', 'hayáis oído', 'hayan oído'],
        'pluperfect subjunctive': ['hubiera oído', 'hubierass oído', 'hubiera oído', 'hubiéramos oído', 'hubierais oído', 'hubieran oído'],
        gerund: 'oyendo',
        participle: 'oído'
    },
    {
        i: 'pedir',
        'present': ['pido', 'pides', 'pide', 'pedimos', 'pedís', 'piden'],
        'imperfect': ['pedía', 'pedías', 'pedía', 'pedíamos', 'pedíais', 'pedían'],
        'future': ['pediré', 'pedirás', 'pedirá', 'pediremos', 'pediréis', 'pedirán'],
        'preterite': ['pedí', 'pediste', 'pidió', 'pedimos', 'pedisteis', 'pidieron'],
        'past perfect': ['he pedido', 'has pedido', 'ha pedido', 'hemos pedido', 'habéis pedido', 'han pedido'],
        'pluperfect': ['había pedido', 'habías pedido', 'había pedido', 'habíamos pedido', 'habíais pedido', 'habían pedido'],
        'future perfect': ['habré pedido', 'habrás pedido', 'habrá pedido', 'habremos pedido', 'habréis pedido', 'habrán pedido'],
        'past anterior': ['hube pedido', 'hubiste pedido', 'hubo pedido', 'hubimos pedido', 'hubisteis pedido', 'hubieron pedido'],
        conditional: ['pediría','pedirías','pediría','pediríamos','pediríais','pedirían'],
        'present subjunctive': ['pida', 'pidas', 'pida', 'pidamos', 'pidáis', 'pidan'],
        'imperfect subjunctive': ['pidiera', 'pidieras', 'pidiera', 'pidiéramos', 'pidierais', 'pidieran'],
        'perfect subjunctive': ['haya pedido', 'hayas pedido', 'haya pedido', 'hayamos pedido', 'hayáis pedido', 'hayan pedido'],
        'pluperfect subjunctive': ['hubiera pedido', 'hubierass pedido', 'hubiera pedido', 'hubiéramos pedido', 'hubierais pedido', 'hubieran pedido'],
        gerund: 'pidiendo',
        participle: 'pedido'
    },
    {
        i: 'poder',
        'present': ['puedo', 'puedes', 'puede', 'podemos', 'podéis', 'pueden'],
        'imperfect': ['podía', 'podías', 'podía', 'podíamos', 'podíais', 'podían'],
        'future': ['podré', 'podrás', 'podrá', 'podremos', 'podréis', 'podrán'],
        'preterite': ['pude', 'pudiste', 'pudo', 'pudimos', 'pudisteis', 'pudieron'],
        'past perfect': ['he podido', 'has podido', 'ha podido', 'hemos podido', 'habéis podido', 'han podido'],
        'pluperfect': ['había podido', 'habías podido', 'había podido', 'habíamos podido', 'habíais podido', 'habían podido'],
        'future perfect': ['habré podido', 'habrás podido', 'habrá podido', 'habremos podido', 'habréis podido', 'habrán podido'],
        'past anterior': ['hube podido', 'hubiste podido', 'hubo podido', 'hubimos podido', 'hubisteis podido', 'hubieron podido'],
        conditional: ['podría','podrías','podría','podríamos','podríais','podrían'],
        'present subjunctive': ['pueda', 'puedas', 'pueda', 'podamos', 'podáis', 'puedan'],
        'imperfect subjunctive': ['pudiera', 'pudierass', 'pudiera', 'pudiéramos', 'pudierais', 'pudieran'],
        'perfect subjunctive': ['haya podido', 'hayas podido', 'haya podido', 'hayamos podido', 'hayáis podido', 'hayan podido'],
        'pluperfect subjunctive': ['hubiera podido', 'hubierass podido', 'hubiera podido', 'hubiéramos podido', 'hubierais podido', 'hubieran podido'],
        gerund: 'pudiendo',
        participle: 'podido'
    },
    {
        i: 'poner',
        'present': ['pongo', 'pones', 'pone', 'ponemos', 'ponéis', 'ponen'],
        'imperfect': ['ponía', 'ponías', 'ponía', 'poníamos', 'poníais', 'ponían'],
        'future': ['pondré', 'pondrás', 'pondrá', 'pondremos', 'pondréis', 'pondrán'],
        'preterite': ['puse', 'pusiste', 'puso', 'pusimos', 'pusisteis', 'pusieron'],
        'past perfect': ['he puesto', 'has puesto', 'ha puesto', 'hemos puesto', 'habéis puesto', 'han puesto'],
        'pluperfect': ['había puesto', 'habías puesto', 'había puesto', 'habíamos puesto', 'habíais puesto', 'habían puesto'],
        'future perfect': ['habré puesto', 'habrás puesto', 'habrá puesto', 'habremos puesto', 'habréis puesto', 'habrán puesto'],
        'past anterior': ['hube puesto', 'hubiste puesto', 'hubo puesto', 'hubimos puesto', 'hubisteis puesto', 'hubieron puesto'],
        conditional: ['pondría','pondrías','pondría','pondríamos','pondríais','pondrían'],
        'present subjunctive': ['ponga', 'pongas', 'ponga', 'pongamos', 'pongáis', 'pongan'],
        'imperfect subjunctive': ['pusiera', 'pusieras', 'pusiera', 'pusiéramos', 'pusierais', 'pusieran'],
        'perfect subjunctive': ['haya puesto', 'hayas puesto', 'haya puesto', 'hayamos puesto', 'hayáis puesto', 'hayan puesto'],
        'pluperfect subjunctive': ['hubiera puesto', 'hubierass puesto', 'hubiera puesto', 'hubiéramos puesto', 'hubierais puesto', 'hubieran puesto'],
        gerund: 'poniendo',
        participle: 'puesto'
    },
    {
        i: 'quedar',
        'present': ['quedo', 'quedas', 'queda', 'quedamos', 'quedáis', 'quedan'],
        'imperfect': ['quedaba', 'quedabas', 'quedaba', 'quedábamos', 'quedabais', 'quedaban'],
        'future': ['quedaré', 'quedarás', 'quedará', 'quedaremos', 'quedaréis', 'quedarán'],
        'preterite': ['quedé', 'quedaste', 'quedó', 'quedamos', 'quedasteis', 'quedaron'],
        'past perfect': ['he quedado', 'has quedado', 'ha quedado', 'hemos quedado', 'habéis quedado', 'han quedado'],
        'pluperfect': ['había quedado', 'habías quedado', 'había quedado', 'habíamos quedado', 'habíais quedado', 'habían quedado'],
        'future perfect': ['habré quedado', 'habrás quedado', 'habrá quedado', 'habremos quedado', 'habréis quedado', 'habrán quedado'],
        'past anterior': ['hube quedado', 'hubiste quedado', 'hubo quedado', 'hubimos quedado', 'hubisteis quedado', 'hubieron quedado'],
        conditional: ['quedaría','quedarías','quedaría','quedaríamos','quedaríais','quedarían'],
        'present subjunctive': ['quede', 'quedes', 'quede', 'quedemos', 'quedéis', 'queden'],
        'imperfect subjunctive': ['quedara', 'quedaras', 'quedara', 'quedáramosásemos', 'quedarais', 'quedaran'],
        'perfect subjunctive': ['haya quedado', 'hayas quedado', 'haya quedado', 'hayamos quedado', 'hayáis quedado', 'hayan quedado'],
        'pluperfect subjunctive': ['hubiera quedado', 'hubieras quedado', 'hubiera quedado', 'hubiéramos quedado', 'hubierais quedado', 'hubieran quedado'],
        gerund: 'quedando',
        participle: 'quedado'
    },
    {
        i: 'querer',
        'present': ['quiero', 'quieres', 'quiere', 'queremos', 'queréis', 'quieren'],
        'imperfect': ['quería', 'querías', 'quería', 'queríamos', 'queríais', 'querían'],
        'future': ['querré', 'querrás', 'querrá', 'querremos', 'querréis', 'querrán'],
        'preterite': ['quise', 'quisiste', 'quiso', 'quisimos', 'quisisteis', 'quisieron'],
        'past perfect': ['he querido', 'has querido', 'ha querido', 'hemos querido', 'habéis querido', 'han querido'],
        'pluperfect': ['había querido', 'habías querido', 'había querido', 'habíamos querido', 'habíais querido', 'habían querido'],
        'future perfect': ['habré querido', 'habrás querido', 'habrá querido', 'habremos querido', 'habréis querido', 'habrán querido'],
        'past anterior': ['hube querido', 'hubiste querido', 'hubo querido', 'hubimos querido', 'hubisteis querido', 'hubieron querido'],
        conditional: ['querría','querrías','querría','querríamos','querríais','querrían'],
        'present subjunctive': ['quiera', 'quieras', 'quiera', 'queramos', 'queráis', 'quieran'],
        'imperfect subjunctive': ['quisiera', 'quisieras', 'quisiera', 'quisiéramos', 'quisierais', 'quisieran'],
        'perfect subjunctive': ['haya querido', 'hayas querido', 'haya querido', 'hayamos querido', 'hayáis querido', 'hayan querido'],
        'pluperfect subjunctive': ['hubiera querido', 'hubieras querido', 'hubiera querido', 'hubiéramos querido', 'hubierais querido', 'hubieran querido'],
        gerund: 'queriendo',
        participle: 'querido'
    },
    {
        i: 'saber',
        'present': ['sé', 'sabes', 'sabe', 'sabemos', 'sabéis', 'saben'],
        'imperfect': ['sabía', 'sabías', 'sabía', 'sabíamos', 'sabíais', 'sabían'],
        'future': ['sabré', 'sabrás', 'sabrá', 'sabremos', 'sabréis', 'sabrán'],
        'preterite': ['supe', 'supiste', 'supo', 'supimos', 'supisteis', 'supieron'],
        'past perfect': ['he sabido', 'has sabido', 'ha sabido', 'hemos sabido', 'habéis sabido', 'han sabido'],
        'pluperfect': ['había sabido', 'habías sabido', 'había sabido', 'habíamos sabido', 'habíais sabido', 'habían sabido'],
        'future perfect': ['habré sabido', 'habrás sabido', 'habrá sabido', 'habremos sabido', 'habréis sabido', 'habrán sabido'],
        'past anterior': ['hube sabido', 'hubiste sabido', 'hubo sabido', 'hubimos sabido', 'hubisteis sabido', 'hubieron sabido'],
        conditional: ['sabría','sabrías','sabría','sabríamos','sabríais','sabrían'],
        'present subjunctive': ['sepa', 'sepas', 'sepa', 'sepamos', 'sepáis', 'sepan'],
        'imperfect subjunctive': ['supiera', 'supieras', 'supiera', 'supiéramos', 'supierais', 'supieran'],
        'perfect subjunctive': ['haya sabido', 'hayas sabido', 'haya sabido', 'hayamos sabido', 'hayáis sabido', 'hayan sabido'],
        'pluperfect subjunctive': ['hubiera sabido', 'hubieras sabido', 'hubiera sabido', 'hubiéramos sabido', 'hubierais sabido', 'hubieran sabido'],
        gerund: 'sabiendo',
        participle: 'sabido'
    },
    {
        i: 'salir',
        'present': ['salgo', 'sales', 'sale', 'salimos', 'salís', 'salen'],
        'imperfect': ['salía', 'salías', 'salía', 'salíamos', 'salíais', 'salían'],
        'future': ['saldré', 'saldrás', 'saldrá', 'saldremos', 'saldréis', 'saldrán'],
        'preterite': ['salí', 'saliste', 'salió', 'salimos', 'salisteis', 'salieron'],
        'past perfect': ['he salido', 'has salido', 'ha salido', 'hemos salido', 'habéis salido', 'han salido'],
        'pluperfect': ['había salido', 'habías salido', 'había salido', 'habíamos salido', 'habíais salido', 'habían salido'],
        'future perfect': ['habré salido', 'habrás salido', 'habrá salido', 'habremos salido', 'habréis salido', 'habrán salido'],
        'past anterior': ['hube salido', 'hubiste salido', 'hubo salido', 'hubimos salido', 'hubisteis salido', 'hubieron salido'],
        conditional: ['saldría','saldrías','saldría','saldríamos','saldríais','saldrían'],
        'present subjunctive': ['salga', 'salgas', 'salga', 'salgamos', 'salgáis', 'salgan'],
        'imperfect subjunctive': ['saliera', 'salieras', 'saliera', 'saliéramos', 'salierais', 'salieran'],
        'perfect subjunctive': ['haya salido', 'hayas salido', 'haya salido', 'hayamos salido', 'hayáis salido', 'hayan salido'],
        'pluperfect subjunctive': ['hubiera salido', 'hubieras salido', 'hubiera salido', 'hubiéramos salido', 'hubierais salido', 'hubieran salido'],
        gerund: 'saliendo',
        participle: 'salido'
    },
    {
        i: 'seguir',
        'present': ['sigo', 'sigues', 'sigue', 'seguimos', 'seguís', 'siguen'],
        'imperfect': ['seguía', 'seguías', 'seguía', 'seguíamos', 'seguíais', 'seguían'],
        'future': ['seguiré', 'seguirás', 'seguirá', 'seguiremos', 'seguiréis', 'seguirán'],
        'preterite': ['seguí', 'seguiste', 'siguió', 'seguimos', 'seguisteis', 'siguieron'],
        'past perfect': ['he seguido', 'has seguido', 'ha seguido', 'hemos seguido', 'habéis seguido', 'han seguido'],
        'pluperfect': ['había seguido', 'habías seguido', 'había seguido', 'habíamos seguido', 'habíais seguido', 'habían seguido'],
        'future perfect': ['habré seguido', 'habrás seguido', 'habrá seguido', 'habremos seguido', 'habréis seguido', 'habrán seguido'],
        'past anterior': ['hube seguido', 'hubiste seguido', 'hubo seguido', 'hubimos seguido', 'hubisteis seguido', 'hubieron seguido'],
        conditional: ['seguiría','seguirías','seguiría','seguiríamos','seguiríais','seguirían'],
        'present subjunctive': ['siga', 'sigas', 'siga', 'sigamos', 'sigáis', 'sigan'],
        'imperfect subjunctive': ['siguiera', 'siguieras', 'siguiera', 'siguiéramos', 'siguierais', 'siguieran'],
        'perfect subjunctive': ['haya seguido', 'hayas seguido', 'haya seguido', 'hayamos seguido', 'hayáis seguido', 'hayan seguido'],
        'pluperfect subjunctive': ['hubiera seguido', 'hubieras seguido', 'hubiera seguido', 'hubiéramos seguido', 'hubierais seguido', 'hubieran seguido'],
        gerund: 'siguiendo',
        participle: 'seguido'
    },
    {
        i: 'sentir',
        'present': ['siento', 'sientes', 'siente', 'sentimos', 'sentís', 'sienten'],
        'imperfect': ['sentía', 'sentías', 'sentía', 'sentíamos', 'sentíais', 'sentían'],
        'future': ['sentiré', 'sentirás', 'sentirá', 'sentiremos', 'sentiréis', 'sentirán'],
        'preterite': ['sentí', 'sentiste', 'sintió', 'sentimos', 'sentisteis', 'sintieron'],
        'past perfect': ['he sentido', 'has sentido', 'ha sentido', 'hemos sentido', 'habéis sentido', 'han sentido'],
        'pluperfect': ['había sentido', 'habías sentido', 'había sentido', 'habíamos sentido', 'habíais sentido', 'habían sentido'],
        'future perfect': ['habré sentido', 'habrás sentido', 'habrá sentido', 'habremos sentido', 'habréis sentido', 'habrán sentido'],
        'past anterior': ['hube sentido', 'hubiste sentido', 'hubo sentido', 'hubimos sentido', 'hubisteis sentido', 'hubieron sentido'],
        conditional: ['sentiría','sentirías','sentiría','sentiríamos','sentiríais','sentirían'],
        'present subjunctive': ['sienta', 'sientas', 'sienta', 'sintamos', 'sintáis', 'sientan'],
        'imperfect subjunctive': ['sintiera', 'sintieras', 'sintiera', 'sintiéramos', 'sintierais', 'sintieran'],
        'perfect subjunctive': ['haya sentido', 'hayas sentido', 'haya sentido', 'hayamos sentido', 'hayáis sentido', 'hayan sentido'],
        'pluperfect subjunctive': ['hubiera sentido', 'hubieras sentido', 'hubiera sentido', 'hubiéramos sentido', 'hubierais sentido', 'hubieran sentido'],
        gerund: 'sintiendo',
        participle: 'sentido'
    },
    {
        i: 'tener',
        'present': ['tengo', 'tienes', 'tiene', 'tenemos', 'tenéis', 'tienen'],
        'imperfect': ['tenía', 'tenías', 'tenía', 'teníamos', 'teníais', 'tenían'],
        'future': ['tendré', 'tendrás', 'tendrá', 'tendremos', 'tendréis', 'tendrán'],
        'preterite': ['tuve', 'tuviste', 'tuvo', 'tuvimos', 'tuvisteis', 'tuvieron'],
        'past perfect': ['he tenido', 'has tenido', 'ha tenido', 'hemos tenido', 'habéis tenido', 'han tenido'],
        'pluperfect': ['había tenido', 'habías tenido', 'había tenido', 'habíamos tenido', 'habíais tenido', 'habían tenido'],
        'future perfect': ['habré tenido', 'habrás tenido', 'habrá tenido', 'habremos tenido', 'habréis tenido', 'habrán tenido'],
        'past anterior': ['hube tenido', 'hubiste tenido', 'hubo tenido', 'hubimos tenido', 'hubisteis tenido', 'hubieron tenido'],
        conditional: ['tendría','tendrías','tendría','tendríamos','tendríais','tendrían'],        
        'present subjunctive': ['tenga', 'tengas', 'tenga', 'tengamos', 'tengáis', 'tengan'],
        'imperfect subjunctive': ['tuviera', 'tuvieras', 'tuviera', 'tuviéramos', 'tuvierais', 'tuvieran'],
        'perfect subjunctive': ['haya tenido', 'hayas tenido', 'haya tenido', 'hayamos tenido', 'hayáis tenido', 'hayan tenido'],
        'pluperfect subjunctive': ['hubiera tenido', 'hubieras tenido', 'hubiera tenido', 'hubiéramos tenido', 'hubierais tenido', 'hubieran tenido'],
        gerund: 'teniendo',
        participle: 'tenido'
    },
    {
        i: 'traer',
        'present': ['traigo', 'traes', 'trae', 'traemos', 'traéis', 'traen'],
        'imperfect': ['traía', 'traías', 'traía', 'traíamos', 'traíais', 'traían'],
        'future': ['traeré', 'traerás', 'traerá', 'traeremos', 'traeréis', 'traerán'],
        'preterite': ['traje', 'trajiste', 'trajo', 'trajimos', 'trajisteis', 'trajeron'],
        'past perfect': ['he traído', 'has traído', 'ha traído', 'hemos traído', 'habéis traído', 'han traído'],
        'pluperfect': ['había traído', 'habías traído', 'había traído', 'habíamos traído', 'habíais traído', 'habían traído'],
        'future perfect': ['habré traído', 'habrás traído', 'habrá traído', 'habremos traído', 'habréis traído', 'habrán traído'],
        'past anterior': ['hube traído', 'hubiste traído', 'hubo traído', 'hubimos traído', 'hubisteis traído', 'hubieron traído'],
        conditional: ['traería','traerías','traería','traeríamos','traeríais','traerían'],
        'present subjunctive': ['traiga', 'traigas', 'traiga', 'traigamos', 'traigáis', 'traigan'],
        'imperfect subjunctive': ['trajera', 'trajeras', 'trajera', 'trajéramos', 'trajerais', 'trajeran'],
        'perfect subjunctive': ['haya traído', 'hayas traído', 'haya traído', 'hayamos traído', 'hayáis traído', 'hayan traído'],
        'pluperfect subjunctive': ['hubiera traído', 'hubieras traído', 'hubiera traído', 'hubiéramos traído', 'hubierais traído', 'hubieran traído'],
        gerund: 'trayendo',
        participle: 'traído'
    },
    {
        i: 'venir',
        'present': ['vengo', 'vienes', 'viene', 'venimos', 'venís', 'vienen'],
        'imperfect': ['venía', 'venías', 'venía', 'veníamos', 'veníais', 'venían'],
        'future': ['vendré', 'vendrás', 'vendrá', 'vendremos', 'vendréis', 'vendrán'],
        'preterite': ['vine', 'viniste', 'vino', 'vinimos', 'vinisteis', 'vinieron'],
        'past perfect': ['he venido', 'has venido', 'ha venido', 'hemos venido', 'habéis venido', 'han venido'],
        'pluperfect': ['había venido', 'habías venido', 'había venido', 'habíamos venido', 'habíais venido', 'habían venido'],
        'future perfect': ['habré venido', 'habrás venido', 'habrá venido', 'habremos venido', 'habréis venido', 'habrán venido'],
        'past anterior': ['hube venido', 'hubiste venido', 'hubo venido', 'hubimos venido', 'hubisteis venido', 'hubieron venido'],
        conditional: ['vendría','vendrías','vendría','vendríamos','vendríais','vendrían'],
        'present subjunctive': ['venga', 'vengas', 'venga', 'vengamos', 'vengáis', 'vengan'],
        'imperfect subjunctive': ['viniera', 'vinieras', 'viniera', 'viniéramos', 'vinierais', 'vinieran'],
        'perfect subjunctive': ['haya venido', 'hayas venido', 'haya venido', 'hayamos venido', 'hayáis venido', 'hayan venido'],
        'pluperfect subjunctive': ['hubiera venido', 'hubieras venido', 'hubiera venido', 'hubiéramos venido', 'hubierais venido', 'hubieran venido'],
        gerund: 'viniendo',
        participle: 'venido'
    },
    {
        i: 'ver',
        'present': ['veo', 'ves', 've', 'vemos', 'veis', 'ven'],
        'imperfect': ['veía', 'veías', 'veía', 'veíamos', 'veíais', 'veían'],
        'future': ['veré', 'verás', 'verá', 'veremos', 'veréis', 'verán'],
        'preterite': ['vi', 'viste', 'vioó', 'vimos', 'visteis', 'vieron'],
        'past perfect': ['he visto', 'has visto', 'ha visto', 'hemos visto', 'habéis visto', 'han visto'],
        'pluperfect': ['había visto', 'habías visto', 'había visto', 'habíamos visto', 'habíais visto', 'habían visto'],
        'future perfect': ['habré visto', 'habrás visto', 'habrá visto', 'habremos visto', 'habréis visto', 'habrán visto'],
        'past anterior': ['hube visto', 'hubiste visto', 'hubo visto', 'hubimos visto', 'hubisteis visto', 'hubieron visto'],
        conditional: ['vería','verías','vería','veríamos','veríais','verían'],
        'present subjunctive': ['vea', 'veas', 'vea', 'veamos', 'veáis', 'vean'],
        'imperfect subjunctive': ['viera', 'vieras', 'viera', 'viéramos', 'vierais', 'vieran'],
        'perfect subjunctive': ['haya visto', 'hayas visto', 'haya visto', 'hayamos visto', 'hayáis visto', 'hayan visto'],
        'pluperfect subjunctive': ['hubiera visto', 'hubieras visto', 'hubiera visto', 'hubiéramos visto', 'hubierais visto', 'hubieran visto'],
        gerund: 'viendo',
        participle: 'visto'
    },
    {
        i: 'volver',
        'present': ['vuelvo', 'vuelves', 'vuelve', 'volvemos', 'volvéis', 'vuelven'],
        'imperfect': ['volvía', 'volvías', 'volvía', 'volvíamos', 'volvíais', 'volvían'],
        'future': ['volveré', 'volverás', 'volverá', 'volveremos', 'volveréis', 'volverán'],
        'preterite': ['volví', 'volviste', 'volvió', 'volvimos', 'volvisteis', 'volvieron'],
        'past perfect': ['he vuelto', 'has vuelto', 'ha vuelto', 'hemos vuelto', 'habéis vuelto', 'han vuelto'],
        'pluperfect': ['había vuelto', 'habías vuelto', 'había vuelto', 'habíamos vuelto', 'habíais vuelto', 'habían vuelto'],
        'future perfect': ['habré vuelto', 'habrás vuelto', 'habrá vuelto', 'habremos vuelto', 'habréis vuelto', 'habrán vuelto'],
        'past anterior': ['hube vuelto', 'hubiste vuelto', 'hubo vuelto', 'hubimos vuelto', 'hubisteis vuelto', 'hubieron vuelto'],
        conditional: ['volvería','volverías','volvería','volveríamos','volveríais','volverían'],
        'present subjunctive': ['vuelva', 'vuelvas', 'vuelva', 'volvamos', 'volváis', 'vuelvan'],
        'perfect subjunctive': ['haya vuelto', 'hayas vuelto', 'haya vuelto', 'hayamos vuelto', 'hayáis vuelto', 'hayan vuelto'],
        'imperfect subjunctive': ['volviera', 'volvieras', 'volviera', 'volviéramos', 'volvierais', 'volvieran'],
        'pluperfect subjunctive': ['hubiera vuelto', 'hubieras vuelto', 'hubiera vuelto', 'hubiéramos vuelto', 'hubierais vuelto', 'hubieran vuelto'],
        gerund: 'volviendo',
        participle: 'vuelto'
    },
    {
        i: 'abrir',
        'present': ['abro', 'abres', 'abre', 'abrimos', 'abrís', 'abren'],
        'imperfect': ['abría', 'abrías', 'abría', 'abríamos', 'abríais', 'abrían'],
        'future': ['abriré', 'abrirás', 'abrirá', 'abriremos', 'abriréis', 'abrirán'],
        'preterite': ['abrí', 'abriste', 'abrió', 'abrimos', 'abristeis', 'abrieron'],
        'past perfect': ['he abierto', 'has abierto', 'ha abierto', 'hemos abierto', 'habéis abierto', 'han abierto'],
        'pluperfect': ['había abierto', 'habías abierto', 'había abierto', 'habíamos abierto', 'habíais abierto', 'habían abierto'],
        'future perfect': ['habré abierto', 'habrás abierto', 'habrá abierto', 'habremos abierto', 'habréis abierto', 'habrán abierto'],
        'past anterior': ['hube abierto', 'hubiste abierto', 'hubo abierto', 'hubimos abierto', 'hubisteis abierto', 'hubieron abierto'],
        conditional: ['abriría','abrirías','abriría','abriríamos','abriríais','abrirían'],
        'present subjunctive': ['abra', 'abras', 'abra', 'abramos', 'abráis', 'abran'],
        'imperfect subjunctive': ['abriera', 'abrieras', 'abriera', 'abriéramos', 'abrierais', 'abrieran'],
        'perfect subjunctive': ['haya abierto', 'hayas abierto', 'haya abierto', 'hayamos abierto', 'hayáis abierto', 'hayan abierto'],
        'pluperfect subjunctive': ['hubiera abierto', 'hubieras abierto', 'hubiera abierto', 'hubiéramos abierto', 'hubierais abierto', 'hubieran abierto'],
        gerund: 'abriendo',
        participle: 'abierto'
    },
    {
        i: 'andar',
        'present': ['ando', 'andas', 'anda', 'andamos', 'andáis', 'andan'],
        'imperfect': ['andaba', 'andabas', 'andaba', 'andábamos', 'andabais', 'andaban'],
        'future': ['andaré', 'andarás', 'andará', 'andaremos', 'andaréis', 'andarán'],
        'preterite': ['anduve', 'anduviste', 'anduvo', 'anduvimos', 'anduvisteis', 'anduvieron'],
        'past perfect': ['he andado', 'has andado', 'ha andado', 'hemos andado', 'habéis andado', 'han andado'],
        'pluperfect': ['había andado', 'habías andado', 'había andado', 'habíamos andado', 'habíais andado', 'habían andado'],
        'future perfect': ['habré andado', 'habrás andado', 'habrá andado', 'habremos andado', 'habréis andado', 'habrán andado'],
        'past anterior': ['hube andado', 'hubiste andado', 'hubo andado', 'hubimos andado', 'hubisteis andado', 'hubieron andado'],
        conditional: ['andaría','andarías','andaría','andaríamos','andaríais','andarían'],
        'present subjunctive': ['ande', 'andes', 'ande', 'andemos', 'andéis', 'anden'],
        'imperfect subjunctive': ['anduviera', 'anduvieras', 'anduviera', 'anduviéramos', 'anduvierais', 'anduvieran'],
        'perfect subjunctive': ['haya andado', 'hayas andado', 'haya andado', 'hayamos andado', 'hayáis andado', 'hayan andado'],
        'pluperfect subjunctive': ['hubiera andado', 'hubieras andado', 'hubiera andado', 'hubiéramos andado', 'hubierais andado', 'hubieran andado'],
        gerund: 'andando',
        participle: 'andado'
    },
    {
        i: 'caer',
        'present': ['caigo', 'caes', 'cae', 'caemos', 'caéis', 'caen'],
        'imperfect': ['caía', 'caías', 'caía', 'caíamos', 'caíais', 'caían'],
        'future': ['caeré', 'caerás', 'caerá', 'caeremos', 'caeréis', 'caerán'],
        'preterite': ['caí', 'caíste', 'cayó', 'caímos', 'caísteis', 'cayeron'],
        'past perfect': ['he caído', 'has caído', 'ha caído', 'hemos caído', 'habéis caído', 'han caído'],
        'pluperfect': ['había caído', 'habías caído', 'había caído', 'habíamos caído', 'habíais caído', 'habían caído'],
        'future perfect': ['habré caído', 'habrás caído', 'habrá caído', 'habremos caído', 'habréis caído', 'habrán caído'],
        'past anterior': ['hube caído', 'hubiste caído', 'hubo caído', 'hubimos caído', 'hubisteis caído', 'hubieron caído'],
        conditional: ['caería','caerías','caería','caeríamos','caeríais','caerían'],
        'present subjunctive': ['caiga', 'caigas', 'caiga', 'caigamos', 'caigáis', 'caigan'],
        'imperfect subjunctive': ['cayera', 'cayeras', 'cayera', 'cayéramos', 'cayerais', 'cayeran'],
        'perfect subjunctive': ['haya caído', 'hayas caído', 'haya caído', 'hayamos caído', 'hayáis caído', 'hayan caído'],
        'pluperfect subjunctive': ['hubiera caído', 'hubieras caído', 'hubiera caído', 'hubiéramos caído', 'hubierais caído', 'hubieran caído'],
        gerund: 'cayendo',
        participle: 'caído'
    },
    {
        i: 'cerrar',
        'present': ['cierro', 'cierras', 'cierra', 'cerramos', 'cerráis', 'cierran'],
        'imperfect': ['cerraba', 'cerrabas', 'cerraba', 'cerrábamos', 'cerrabais', 'cerraban'],
        'future': ['cerraré', 'cerrarás', 'cerrará', 'cerraremos', 'cerraréis', 'cerrarán'],
        'preterite': ['cerré', 'cerraste', 'cerró', 'cerramos', 'cerrasteis', 'cerraron'],
        'past perfect': ['he cerrado', 'has cerrado', 'ha cerrado', 'hemos cerrado', 'habéis cerrado', 'han cerrado'],
        'pluperfect': ['había cerrado', 'habías cerrado', 'había cerrado', 'habíamos cerrado', 'habíais cerrado', 'habían cerrado'],
        'future perfect': ['habré cerrado', 'habrás cerrado', 'habrá cerrado', 'habremos cerrado', 'habréis cerrado', 'habrán cerrado'],
        'past anterior': ['hube cerrado', 'hubiste cerrado', 'hubo cerrado', 'hubimos cerrado', 'hubisteis cerrado', 'hubieron cerrado'],
        conditional: ['cerraría','cerrarías','cerraría','cerraríamos','cerraríais','cerrarían'],
        'present subjunctive': ['cierre', 'cierres', 'cierre', 'cerremos', 'cerréis', 'cierren'],
        'imperfect subjunctive': ['cerrara', 'cerraras', 'cerrara', 'cerráramosásemos', 'cerrarais', 'cerraran'],
        'perfect subjunctive': ['haya cerrado', 'hayas cerrado', 'haya cerrado', 'hayamos cerrado', 'hayáis cerrado', 'hayan cerrado'],
        'pluperfect subjunctive': ['hubiera cerrado', 'hubieras cerrado', 'hubiera cerrado', 'hubiéramos cerrado', 'hubierais cerrado', 'hubieran cerrado'],
        gerund: 'cerrando',
        participle: 'cerrado'
    },
    {
        i: 'conocer',
        'present': ['conozco', 'conoces', 'conoce', 'conocemos', 'conocéis', 'conocen'],
        'imperfect': ['conocía', 'conocías', 'conocía', 'conocíamos', 'conocíais', 'conocían'],
        'future': ['conoceré', 'conocerás', 'conocerá', 'conoceremos', 'conoceréis', 'conocerán'],
        'preterite': ['conocí', 'conociste', 'conoció', 'conocimos', 'conocisteis', 'conocieron'],
        'past perfect': ['he conocido', 'has conocido', 'ha conocido', 'hemos conocido', 'habéis conocido', 'han conocido'],
        'pluperfect': ['había conocido', 'habías conocido', 'había conocido', 'habíamos conocido', 'habíais conocido', 'habían conocido'],
        'future perfect': ['habré conocido', 'habrás conocido', 'habrá conocido', 'habremos conocido', 'habréis conocido', 'habrán conocido'],
        'past anterior': ['hube conocido', 'hubiste conocido', 'hubo conocido', 'hubimos conocido', 'hubisteis conocido', 'hubieron conocido'],
        conditional: ['conocería','conocerías','conocería','conoceríamos','conoceríais','conocerían'],
        'present subjunctive': ['conozca', 'conozcas', 'conozca', 'conozcamos', 'conozcáis', 'conozcan'],
        'imperfect subjunctive': ['conociera', 'conocieras', 'conociera', 'conociéramos', 'conocierais', 'conocieran'],
        'perfect subjunctive': ['haya conocido', 'hayas conocido', 'haya conocido', 'hayamos conocido', 'hayáis conocido', 'hayan conocido'],
        'pluperfect subjunctive': ['hubiera conocido', 'hubieras conocido', 'hubiera conocido', 'hubiéramos conocido', 'hubierais conocido', 'hubieran conocido'],
        gerund: 'conociendo',
        participle: 'conocido'
    },
    {
        i: 'creer',
        'present': ['creo', 'crees', 'cree', 'creemos', 'creéis', 'creen'],
        'imperfect': ['creía', 'creías', 'creía', 'creíamos', 'creíais', 'creían'],
        'future': ['creeré', 'creerás', 'creerá', 'creeremos', 'creeréis', 'creerán'],
        'preterite': ['creí', 'creíste', 'creyó', 'creímos', 'creísteis', 'creyeron'],
        'past perfect': ['he creído', 'has creído', 'ha creído', 'hemos creído', 'habéis creído', 'han creído'],
        'pluperfect': ['había creído', 'habías creído', 'había creído', 'habíamos creído', 'habíais creído', 'habían creído'],
        'future perfect': ['habré creído', 'habrás creído', 'habrá creído', 'habremos creído', 'habréis creído', 'habrán creído'],
        'past anterior': ['hube creído', 'hubiste creído', 'hubo creído', 'hubimos creído', 'hubisteis creído', 'hubieron creído'],
        conditional: ['creería','creerías','creería','creeríamos','creeríais','creerían'],
        'present subjunctive': ['crea', 'creas', 'crea', 'creamos', 'creáis', 'crean'],
        'imperfect subjunctive': ['creyera', 'creyeras', 'creyera', 'creyéramos', 'creyerais', 'creyeran'],
        'perfect subjunctive': ['haya creído', 'hayas creído', 'haya creído', 'hayamos creído', 'hayáis creído', 'hayan creído'],
        'pluperfect subjunctive': ['hubiera creído', 'hubieras creído', 'hubiera creído', 'hubiéramos creído', 'hubierais creído', 'hubieran creído'],
        gerund: 'creyendo',
        participle: 'creído'
    },
    {
        i: 'dormir',
        'present': ['duermo', 'duermes', 'duerme', 'dormimos', 'dormís', 'duermen'],
        'imperfect': ['dormía', 'dormías', 'dormía', 'dormíamos', 'dormíais', 'dormían'],
        'future': ['dormiré', 'dormirás', 'dormirá', 'dormiremos', 'dormiréis', 'dormirán'],
        'preterite': ['dormí', 'dormiste', 'durmió', 'dormimos', 'dormisteis', 'durmieron'],
        'past perfect': ['he dormido', 'has dormido', 'ha dormido', 'hemos dormido', 'habéis dormido', 'han dormido'],
        'pluperfect': ['había dormido', 'habías dormido', 'había dormido', 'habíamos dormido', 'habíais dormido', 'habían dormido'],
        'future perfect': ['habré dormido', 'habrás dormido', 'habrá dormido', 'habremos dormido', 'habréis dormido', 'habrán dormido'],
        'past anterior': ['hube dormido', 'hubiste dormido', 'hubo dormido', 'hubimos dormido', 'hubisteis dormido', 'hubieron dormido'],
        conditional: ['dormiría','dormirías','dormiría','dormiríamos','dormiríais','dormirían'],
        'present subjunctive': ['duerma', 'duermas', 'duerma', 'durmamos', 'durmáis', 'duerman'],
        'imperfect subjunctive': ['durmiera', 'durmieras', 'durmiera', 'durmiéramos', 'durmierais', 'durmieran'],
        'perfect subjunctive': ['haya dormido', 'hayas dormido', 'haya dormido', 'hayamos dormido', 'hayáis dormido', 'hayan dormido'],
        'pluperfect subjunctive': ['hubiera dormido', 'hubieras dormido', 'hubiera dormido', 'hubiéramos dormido', 'hubierais dormido', 'hubieran dormido'],
        gerund: 'durmiendo',
        participle: 'dormido'
    },
    {
        i: 'empezar',
        'present': ['empiezo', 'empiezas', 'empieza', 'empezamos', 'empezáis', 'empiezan'],
        'imperfect': ['empezaba', 'empezabas', 'empezaba', 'empezábamos', 'empezabais', 'empezaban'],
        'future': ['empezaré', 'empezarás', 'empezará', 'empezaremos', 'empezaréis', 'empezarán'],
        'preterite': ['empecé', 'empezaste', 'empezó', 'empezamos', 'empezasteis', 'empezaron'],
        'past perfect': ['he empezado', 'has empezado', 'ha empezado', 'hemos empezado', 'habéis empezado', 'han empezado'],
        'pluperfect': ['había empezado', 'habías empezado', 'había empezado', 'habíamos empezado', 'habíais empezado', 'habían empezado'],
        'future perfect': ['habré empezado', 'habrás empezado', 'habrá empezado', 'habremos empezado', 'habréis empezado', 'habrán empezado'],
        'past anterior': ['hube empezado', 'hubiste empezado', 'hubo empezado', 'hubimos empezado', 'hubisteis empezado', 'hubieron empezado'],
        conditional: ['empezaría','empezarías','empezaría','empezaríamos','empezaríais','empezarían'],
        'present subjunctive': ['empiece', 'empieces', 'empiece', 'empecemos', 'empecéis', 'empiecen'],
        'imperfect subjunctive': ['empezara', 'empezaras', 'empezara', 'empezáramosásemos', 'empezarais', 'empezaran'],
        'perfect subjunctive': ['haya empezado', 'hayas empezado', 'haya empezado', 'hayamos empezado', 'hayáis empezado', 'hayan empezado'],
        'pluperfect subjunctive': ['hubiera empezado', 'hubieras empezado', 'hubiera empezado', 'hubiéramos empezado', 'hubierais empezado', 'hubieran empezado'],
        gerund: 'empezando',
        participle: 'empezado'
    },
    {
        i: 'escoger',
        'present': ['escojo', 'escoges', 'escoge', 'escogemos', 'escogéis', 'escogen'],
        'imperfect': ['escogía', 'escogías', 'escogía', 'escogíamos', 'escogíais', 'escogían'],
        'future': ['escogeré', 'escogerás', 'escogerá', 'escogeremos', 'escogeréis', 'escogerán'],
        'preterite': ['escogí', 'escogiste', 'escogió', 'escogimos', 'escogisteis', 'escogieron'],
        'past perfect': ['he escogido', 'has escogido', 'ha escogido', 'hemos escogido', 'habéis escogido', 'han escogido'],
        'pluperfect': ['había escogido', 'habías escogido', 'había escogido', 'habíamos escogido', 'habíais escogido', 'habían escogido'],
        'future perfect': ['habré escogido', 'habrás escogido', 'habrá escogido', 'habremos escogido', 'habréis escogido', 'habrán escogido'],
        'past anterior': ['hube escogido', 'hubiste escogido', 'hubo escogido', 'hubimos escogido', 'hubisteis escogido', 'hubieron escogido'],
        conditional: ['escogería','escogerías','escogería','escogeríamos','escogeríais','escogerían'],
        'present subjunctive': ['escoja', 'escojas', 'escoja', 'escojamos', 'escojáis', 'escojan'],
        'imperfect subjunctive': ['escogiera', 'escogieras', 'escogiera', 'escogiéramos', 'escogierais', 'escogieran'],
        'perfect subjunctive': ['haya escogido', 'hayas escogido', 'haya escogido', 'hayamos escogido', 'hayáis escogido', 'hayan escogido'],
        'pluperfect subjunctive': ['hubiera escogido', 'hubieras escogido', 'hubiera escogido', 'hubiéramos escogido', 'hubierais escogido', 'hubieran escogido'],
        gerund: 'escogiendo',
        participle: 'escogido'
    },
    {
        i: 'encontrar',
        'present': ['encuentro', 'encuentras', 'encuentra', 'encontramos', 'encontráis', 'encuentran'],
        'imperfect': ['encontraba', 'encontrabas', 'encontraba', 'encontrábamos', 'encontrabais', 'encontraban'],
        'future': ['encontraré', 'encontrarás', 'encontrará', 'encontraremos', 'encontraréis', 'encontrarán'],
        'preterite': ['encontré', 'encontraste', 'encontró', 'encontramos', 'encontrasteis', 'encontraron'],
        'past perfect': ['he encontrado', 'has encontrado', 'ha encontrado', 'hemos encontrado', 'habéis encontrado', 'han encontrado'],
        'pluperfect': ['había encontrado', 'habías encontrado', 'había encontrado', 'habíamos encontrado', 'habíais encontrado', 'habían encontrado'],
        'future perfect': ['habré encontrado', 'habrás encontrado', 'habrá encontrado', 'habremos encontrado', 'habréis encontrado', 'habrán encontrado'],
        'past anterior': ['hube encontrado', 'hubiste encontrado', 'hubo encontrado', 'hubimos encontrado', 'hubisteis encontrado', 'hubieron encontrado'],
        conditional: ['encontraría','encontrarías','encontraría','encontraríamos','encontraríais','encontrarían'],
        'present subjunctive': ['encuentre', 'encuentres', 'encuentre', 'encontremos', 'encontréis', 'encuentren'],
        'imperfect subjunctive': ['encontrara', 'encontraras', 'encontrara', 'encontráramosásemos', 'encontrarais', 'encontraran'],
        'perfect subjunctive': ['haya encontrado', 'hayas encontrado', 'haya encontrado', 'hayamos encontrado', 'hayáis encontrado', 'hayan encontrado'],
        'pluperfect subjunctive': ['hubiera encontrado', 'hubieras encontrado', 'hubiera encontrado', 'hubiéramos encontrado', 'hubierais encontrado', 'hubieran encontrado'],
        gerund: 'encontrando',
        participle: 'encontrado'
    },
    {
        i: 'escribir',
        'present': ['escribo', 'escribes', 'escribe', 'escribimos', 'escribís', 'escriben'],
        'imperfect': ['escribía', 'escribías', 'escribía', 'escribíamos', 'escribíais', 'escribían'],
        'future': ['escribiré', 'escribirás', 'escribirá', 'escribiremos', 'escribiréis', 'escribirán'],
        'preterite': ['escribí', 'escribiste', 'escribió', 'escribimos', 'escribisteis', 'escribieron'],
        'past perfect': ['he escrito', 'has escrito', 'ha escrito', 'hemos escrito', 'habéis escrito', 'han escrito'],
        'pluperfect': ['había escrito', 'habías escrito', 'había escrito', 'habíamos escrito', 'habíais escrito', 'habían escrito'],
        'future perfect': ['habré escrito', 'habrás escrito', 'habrá escrito', 'habremos escrito', 'habréis escrito', 'habrán escrito'],
        'past anterior': ['hube escrito', 'hubiste escrito', 'hubo escrito', 'hubimos escrito', 'hubisteis escrito', 'hubieron escrito'],
        conditional: ['escribiría','escribirías','escribiría','escribiríamos','escribiríais','escribirían'],
        'present subjunctive': ['escriba', 'escribas', 'escriba', 'escribamos', 'escribáis', 'escriban'],
        'imperfect subjunctive': ['escribiera', 'escribieras', 'escribiera', 'escribiéramos', 'escribierais', 'escribieran'],
        'perfect subjunctive': ['haya escrito', 'hayas escrito', 'haya escrito', 'hayamos escrito', 'hayáis escrito', 'hayan escrito'],
        'pluperfect subjunctive': ['hubiera escrito', 'hubieras escrito', 'hubiera escrito', 'hubiéramos escrito', 'hubierais escrito', 'hubieran escrito'],
        gerund: 'escribiendo',
        participle: 'escrito'
    },
    {
        i: 'jugar',
        'present': ['juego', 'juegas', 'juega', 'jugamos', 'jugáis', 'juegan'],
        'imperfect': ['jugaba', 'jugabas', 'jugaba', 'jugábamos', 'jugabais', 'jugaban'],
        'future': ['jugaré', 'jugarás', 'jugará', 'jugaremos', 'jugaréis', 'jugarán'],
        'preterite': ['jugué', 'jugaste', 'jugó', 'jugamos', 'jugasteis', 'jugaron'],
        'past perfect': ['he jugado', 'has jugado', 'ha jugado', 'hemos jugado', 'habéis jugado', 'han jugado'],
        'pluperfect': ['había jugado', 'habías jugado', 'había jugado', 'habíamos jugado', 'habíais jugado', 'habían jugado'],
        'future perfect': ['habré jugado', 'habrás jugado', 'habrá jugado', 'habremos jugado', 'habréis jugado', 'habrán jugado'],
        'past anterior': ['hube jugado', 'hubiste jugado', 'hubo jugado', 'hubimos jugado', 'hubisteis jugado', 'hubieron jugado'],
        conditional: ['jugaría','jugarías','jugaría','jugaríamos','jugaríais','jugarían'],
        'present subjunctive': ['juegue', 'juegues', 'juegue', 'juguemos', 'juguéis', 'jueguen'],
        'imperfect subjunctive': ['jugara', 'jugaras', 'jugara', 'jugáramosásemos', 'jugarais', 'jugaran'],
        'perfect subjunctive': ['haya jugado', 'hayas jugado', 'haya jugado', 'hayamos jugado', 'hayáis jugado', 'hayan jugado'],
        'pluperfect subjunctive': ['hubiera jugado', 'hubieras jugado', 'hubiera jugado', 'hubiéramos jugado', 'hubierais jugado', 'hubieran jugado'],
        gerund: 'jugando',
        participle: 'jugado'
    },
    {
        i: 'mirar',
        'present': ['miro', 'miras', 'mira', 'miramos', 'miráis', 'miran'],
        'imperfect': ['miraba', 'mirabas', 'miraba', 'mirábamos', 'mirabais', 'miraban'],
        'future': ['miraré', 'mirarás', 'mirará', 'miraremos', 'miraréis', 'mirarán'],
        'preterite': ['miré', 'miraste', 'miró', 'miramos', 'mirasteis', 'miraron'],
        'past perfect': ['he mirado', 'has mirado', 'ha mirado', 'hemos mirado', 'habéis mirado', 'han mirado'],
        'pluperfect': ['había mirado', 'habías mirado', 'había mirado', 'habíamos mirado', 'habíais mirado', 'habían mirado'],
        'future perfect': ['habré mirado', 'habrás mirado', 'habrá mirado', 'habremos mirado', 'habréis mirado', 'habrán mirado'],
        'past anterior': ['hube mirado', 'hubiste mirado', 'hubo mirado', 'hubimos mirado', 'hubisteis mirado', 'hubieron mirado'],
        conditional: ['miraría','mirarías','miraría','miraríamos','miraríais','mirarían'],
        'present subjunctive': ['mire', 'mires', 'mire', 'miremos', 'miréis', 'miren'],
        'imperfect subjunctive': ['mirara', 'miraras', 'mirara', 'miráramosásemos', 'mirarais', 'miraran'],
        'perfect subjunctive': ['haya mirado', 'hayas mirado', 'haya mirado', 'hayamos mirado', 'hayáis mirado', 'hayan mirado'],
        'pluperfect subjunctive': ['hubiera mirado', 'hubieras mirado', 'hubiera mirado', 'hubiéramos mirado', 'hubierais mirado', 'hubieran mirado'],
        gerund: 'mirando',
        participle: 'mirado'
    },
    {
        i: 'olvidar',
        'present': ['olvido', 'olvidas', 'olvida', 'olvidamos', 'olvidáis', 'olvidan'],
        'imperfect': ['olvidaba', 'olvidabas', 'olvidaba', 'olvidábamos', 'olvidabais', 'olvidaban'],
        'future': ['olvidaré', 'olvidarás', 'olvidará', 'olvidaremos', 'olvidaréis', 'olvidarán'],
        'preterite': ['olvidé', 'olvidaste', 'olvidó', 'olvidamos', 'olvidasteis', 'olvidaron'],
        'past perfect': ['he olvidado', 'has olvidado', 'ha olvidado', 'hemos olvidado', 'habéis olvidado', 'han olvidado'],
        'pluperfect': ['había olvidado', 'habías olvidado', 'había olvidado', 'habíamos olvidado', 'habíais olvidado', 'habían olvidado'],
        'future perfect': ['habré olvidado', 'habrás olvidado', 'habrá olvidado', 'habremos olvidado', 'habréis olvidado', 'habrán olvidado'],
        'past anterior': ['hube olvidado', 'hubiste olvidado', 'hubo olvidado', 'hubimos olvidado', 'hubisteis olvidado', 'hubieron olvidado'],
        conditional: ['olvidaría','olvidarías','olvidaría','olvidaríamos','olvidaríais','olvidarían'],
        'present subjunctive': ['olvide', 'olvides', 'olvide', 'olvidemos', 'olvidéis', 'olviden'],
        'imperfect subjunctive': ['olvidara', 'olvidaras', 'olvidara', 'olvidáramosásemos', 'olvidarais', 'olvidaran'],
        'perfect subjunctive': ['haya olvidado', 'hayas olvidado', 'haya olvidado', 'hayamos olvidado', 'hayáis olvidado', 'hayan olvidado'],
        'pluperfect subjunctive': ['hubiera olvidado', 'hubieras olvidado', 'hubiera olvidado', 'hubiéramos olvidado', 'hubierais olvidado', 'hubieran olvidado'],
        gerund: 'olvidando',
        participle: 'olvidado'
    },
    {
        i: 'pagar',
        'present': ['pago', 'pagas', 'paga', 'pagamos', 'pagáis', 'pagan'],
        'imperfect': ['pagaba', 'pagabas', 'pagaba', 'pagábamos', 'pagabais', 'pagaban'],
        'future': ['pagaré', 'pagarás', 'pagará', 'pagaremos', 'pagaréis', 'pagarán'],
        'preterite': ['pagué', 'pagaste', 'pagó', 'pagamos', 'pagasteis', 'pagaron'],
        'past perfect': ['he pagado', 'has pagado', 'ha pagado', 'hemos pagado', 'habéis pagado', 'han pagado'],
        'pluperfect': ['había pagado', 'habías pagado', 'había pagado', 'habíamos pagado', 'habíais pagado', 'habían pagado'],
        'future perfect': ['habré pagado', 'habrás pagado', 'habrá pagado', 'habremos pagado', 'habréis pagado', 'habrán pagado'],
        'past anterior': ['hube pagado', 'hubiste pagado', 'hubo pagado', 'hubimos pagado', 'hubisteis pagado', 'hubieron pagado'],
        conditional: ['pagaría','pagarías','pagaría','pagaríamos','pagaríais','pagarían'],
        'present subjunctive': ['pague', 'pagues', 'pague', 'paguemos', 'paguéis', 'paguen'],
        'imperfect subjunctive': ['pagara', 'pagaras', 'pagara', 'pagáramosásemos', 'pagarais', 'pagaran'],
        'perfect subjunctive': ['haya pagado', 'hayas pagado', 'haya pagado', 'hayamos pagado', 'hayáis pagado', 'hayan pagado'],
        'pluperfect subjunctive': ['hubiera pagado', 'hubieras pagado', 'hubiera pagado', 'hubiéramos pagado', 'hubierais pagado', 'hubieran pagado'],
        gerund: 'pagando',
        participle: 'pagado'
    },
    {
        i: 'pensar',
        'present': ['pienso', 'piensas', 'piensa', 'pensamos', 'pensáis', 'piensan'],
        'imperfect': ['pensaba', 'pensabas', 'pensaba', 'pensábamos', 'pensabais', 'pensaban'],
        'future': ['pensaré', 'pensarás', 'pensará', 'pensaremos', 'pensaréis', 'pensarán'],
        'preterite': ['pensé', 'pensaste', 'pensó', 'pensamos', 'pensasteis', 'pensaron'],
        'past perfect': ['he pensado', 'has pensado', 'ha pensado', 'hemos pensado', 'habéis pensado', 'han pensado'],
        'pluperfect': ['había pensado', 'habías pensado', 'había pensado', 'habíamos pensado', 'habíais pensado', 'habían pensado'],
        'future perfect': ['habré pensado', 'habrás pensado', 'habrá pensado', 'habremos pensado', 'habréis pensado', 'habrán pensado'],
        'past anterior': ['hube pensado', 'hubiste pensado', 'hubo pensado', 'hubimos pensado', 'hubisteis pensado', 'hubieron pensado'],
        conditional: ['pensaría','pensarías','pensaría','pensaríamos','pensaríais','pensarían'],
        'present subjunctive': ['piense', 'pienses', 'piense', 'pensemos', 'penséis', 'piensen'],
        'imperfect subjunctive': ['pensara', 'pensaras', 'pensara', 'pensáramosásemos', 'pensarais', 'pensaran'],
        'perfect subjunctive': ['haya pensado', 'hayas pensado', 'haya pensado', 'hayamos pensado', 'hayáis pensado', 'hayan pensado'],
        'pluperfect subjunctive': ['hubiera pensado', 'hubieras pensado', 'hubiera pensado', 'hubiéramos pensado', 'hubierais pensado', 'hubieran pensado'],
        gerund: 'pensando',
        participle: 'pensado'
    },
    {
        i: 'perder',
        'present': ['pierdo', 'pierdes', 'pierde', 'perdemos', 'perdéis', 'pierden'],
        'imperfect': ['perdía', 'perdías', 'perdía', 'perdíamos', 'perdíais', 'perdían'],
        'future': ['perderé', 'perderás', 'perderá', 'perderemos', 'perderéis', 'perderán'],
        'preterite': ['perdí', 'perdiste', 'perdió', 'perdimos', 'perdisteis', 'perdieron'],
        'past perfect': ['he perdido', 'has perdido', 'ha perdido', 'hemos perdido', 'habéis perdido', 'han perdido'],
        'pluperfect': ['había perdido', 'habías perdido', 'había perdido', 'habíamos perdido', 'habíais perdido', 'habían perdido'],
        'future perfect': ['habré perdido', 'habrás perdido', 'habrá perdido', 'habremos perdido', 'habréis perdido', 'habrán perdido'],
        'past anterior': ['hube perdido', 'hubiste perdido', 'hubo perdido', 'hubimos perdido', 'hubisteis perdido', 'hubieron perdido'],
        conditional: ['perdería','perderías','perdería','perderíamos','perderíais','perderían'],
        'present subjunctive': ['pierda', 'pierdas', 'pierda', 'perdamos', 'perdáis', 'pierdan'],
        'imperfect subjunctive': ['perdiera', 'perdieras', 'perdiera', 'perdiéramos', 'perdierais', 'perdieran'],
        'perfect subjunctive': ['haya perdido', 'hayas perdido', 'haya perdido', 'hayamos perdido', 'hayáis perdido', 'hayan perdido'],
        'pluperfect subjunctive': ['hubiera perdido', 'hubieras perdido', 'hubiera perdido', 'hubiéramos perdido', 'hubierais perdido', 'hubieran perdido'],
        gerund: 'perdiendo',
        participle: 'perdido'
    },
    {
        i: 'sacar',
        'present': ['saco', 'sacas', 'saca', 'sacamos', 'sacáis', 'sacan'],
        'imperfect': ['sacaba', 'sacabas', 'sacaba', 'sacábamos', 'sacabais', 'sacaban'],
        'future': ['sacaré', 'sacarás', 'sacará', 'sacaremos', 'sacaréis', 'sacarán'],
        'preterite': ['saqué', 'sacaste', 'sacó', 'sacamos', 'sacasteis', 'sacaron'],
        'past perfect': ['he sacado', 'has sacado', 'ha sacado', 'hemos sacado', 'habéis sacado', 'han sacado'],
        'pluperfect': ['había sacado', 'habías sacado', 'había sacado', 'habíamos sacado', 'habíais sacado', 'habían sacado'],
        'future perfect': ['habré sacado', 'habrás sacado', 'habrá sacado', 'habremos sacado', 'habréis sacado', 'habrán sacado'],
        'past anterior': ['hube sacado', 'hubiste sacado', 'hubo sacado', 'hubimos sacado', 'hubisteis sacado', 'hubieron sacado'],
        conditional: ['sacaría','sacarías','sacaría','sacaríamos','sacaríais','sacarían'],
        'present subjunctive': ['saque', 'saques', 'saque', 'saquemos', 'saquéis', 'saquen'],
        'imperfect subjunctive': ['sacara', 'sacaras', 'sacara', 'sacáramosásemos', 'sacarais', 'sacaran'],
        'perfect subjunctive': ['haya sacado', 'hayas sacado', 'haya sacado', 'hayamos sacado', 'hayáis sacado', 'hayan sacado'],
        'pluperfect subjunctive': ['hubiera sacado', 'hubieras sacado', 'hubiera sacado', 'hubiéramos sacado', 'hubierais sacado', 'hubieran sacado'],
        gerund: 'sacando',
        participle: 'sacado'
    },
    {
        i: 'valer',
        'present': ['valgo', 'vales', 'vale', 'valemos', 'valéis', 'valen'],
        'imperfect': ['valía', 'valías', 'valía', 'valíamos', 'valíais', 'valían'],
        'future': ['valdré', 'valdrás', 'valdrá', 'valdremos', 'valdréis', 'valdrán'],
        'preterite': ['valí', 'valiste', 'valió', 'valimos', 'valisteis', 'valieron'],
        'past perfect': ['he valido', 'has valido', 'ha valido', 'hemos valido', 'habéis valido', 'han valido'],
        'pluperfect': ['había valido', 'habías valido', 'había valido', 'habíamos valido', 'habíais valido', 'habían valido'],
        'future perfect': ['habré valido', 'habrás valido', 'habrá valido', 'habremos valido', 'habréis valido', 'habrán valido'],
        'past anterior': ['hube valido', 'hubiste valido', 'hubo valido', 'hubimos valido', 'hubisteis valido', 'hubieron valido'],
        conditional: ['valdría','valdrías','valdría','valdríamos','valdríais','valdrían'],
        'present subjunctive': ['valga', 'valgas', 'valga', 'valgamos', 'valgáis', 'valgan'],
        'imperfect subjunctive': ['valiera', 'valieras', 'valiera', 'valiéramos', 'valierais', 'valieran'],
        'perfect subjunctive': ['haya valido', 'hayas valido', 'haya valido', 'hayamos valido', 'hayáis valido', 'hayan valido'],
        'pluperfect subjunctive': ['hubiera valido', 'hubieras valido', 'hubiera valido', 'hubiéramos valido', 'hubierais valido', 'hubieran valido'],
        gerund: 'valiendo',
        participle: 'valido'
    },
    {
        i: 'haber',
        "present": ["he", "has", "ha", "hemos", "habéis", "han"],
        "imperfect": ["había", "habías", "había", "habíamos", "habíais", "habían"],
        "future": ["habré", "habrás", "habrá", "habremos", "habréis", "habrán"],
        "preterite": ["hube", "hubiste", "hubo", "hubimos", "hubisteis", "hubieron"],
        "past perfect": ["he habido", "has habido", "ha habido", "hemos habido", "habéis habido", "han habido"],
        "pluperfect": ["había habido", "habías habido", "había habido", "habíamos habido", "habíais habido", "habían habido"],
        "future perfect": ["habré habido", "habrás habido", "habrá habido", "habremos habido", "habréis habido", "habrán habido"],
        "past anterior": ["hube habido", "hubiste habido", "hubo habido", "hubimos habido", "hubisteis habido", "hubieron habido"],
        conditional: ['habría','habrías','habría','habríamos','habríais','habrían'],
        "present subjunctive": ["haya", "hayas", "haya", "hayamos", "hayáis", "hayan"],
        "imperfect subjunctive": ["hubiera", "hubieras", "hubiera", "hubiéramos", "hubierais", "hubieran"],
        "perfect subjunctive": ["haya habido", "hayas habido", "haya habido", "hayamos habido", "hayáis habido", "hayan habido"],
        "pluperfect subjunctive": ["hubiera habido", "hubieras habido", "hubiera habido", "hubiéramos habido", "hubierais habido", "hubieran habido"],
        gerund: 'habiendo',
        participle: 'habido'
    },
    {
        i: 'reír',
        "present": ["río", "ríes", "ríe", "reímos", "reís", "ríen"],
        "imperfect": ["reía", "reías", "reía", "reíamos", "reíais", "reían"],
        "future": ["reiré", "reirás", "reirá", "reiremos", "reiréis", "reirán"],
        "preterite": ["reí", "reíste", "rió", "reímos", "reísteis", "rieron"],
        "past perfect": ["he reído", "has reído", "ha reído", "hemos reído", "habéis reído", "han reído"],
        "pluperfect": ["había reído", "habías reído", "había reído", "habíamos reído", "habíais reído", "habían reído"],
        "future perfect": ["habré reído", "habrás reído", "habrá reído", "habremos reído", "habréis reído", "habrán reído"],
        "past anterior": ["hube reído", "hubiste reído", "hubo reído", "hubimos reído", "hubisteis reído", "hubieron reído"],
        conditional: ['reiría','reirías','reiría','reiríamos','reiríais','reirían'],
        "present subjunctive": ["ría", "rías", "ría", "riamos", "riais", "rían"],
        "imperfect subjunctive": ["riera", "rieras", "riera", "riéramos", "rierais", "rieran"],
        "past perfect subjunctive": ["haya reído", "hayas reído", "haya reído", "hayamos reído", "hayáis reído", "hayan reído"],
        "pluperfect subjunctive": ["hubiera reído", "hubieras reído", "hubiera reído", "hubiéramos reído", "hubierais reído", "hubieran reído"],
        gerund: 'riendo',
        participle: 'reído'
    },
    {
        i: 'caber',
        "present": ["quepo", "cabes", "cabe", "cabemos", "cabéis", "caben"],
        "imperfect": ["cabía", "cabías", "cabía", "cabíamos", "cabíais", "cabían"],
        "future": ["cabré", "cabrás", "cabrá", "cabremos", "cabréis", "cabrán"],
        "preterite": ["cupe", "cupiste", "cupo", "cupimos", "cupisteis", "cupieron"],
        "past perfect": ["he cabido", "has cabido", "ha cabido", "hemos cabido", "habéis cabido", "han cabido"],
        "pluperfect": ["había cabido", "habías cabido", "había cabido", "habíamos cabido", "habíais cabido", "habían cabido"],
        "future perfect": ["habré cabido", "habrás cabido", "habrá cabido", "habremos cabido", "habréis cabido", "habrán cabido"],
        "past anterior": ["hube cabido", "hubiste cabido", "hubo cabido", "hubimos cabido", "hubisteis cabido", "hubieron cabido"],
        conditional: ['cabría','cabrías','cabría','cabríamos','cabríais','cabrían'],
        "present subjunctive": ["quepa", "quepas", "quepa", "quepamos", "quepáis", "quepan"],
        "imperfect subjunctive": ["cupiera", "cupieras", "cupiera", "cupiéramos", "cupierais", "cupieran"],
        "past perfect subjunctive": ["haya cabido", "hayas cabido", "haya cabido", "hayamos cabido", "hayáis cabido", "hayan cabido"],
        "pluperfect subjunctive": ["hubiera cabido", "hubieras cabido", "hubiera cabido", "hubiéramos cabido", "hubierais cabido", "hubieran cabido"],
        gerund: 'cabiendo',
        participle: 'cabido'
    }
];

export const esPartials = [
    {
        i: 'parecer',
        present: ['parezco', '', '', '', '', ''],
        'present subjunctive': [
            'parezca',
            'parezcas',
            'parezca',
            'parezcamos',
            'parezcáis',
            'parezcan',
        ]
    },
    {
        i: 'surgir',
        present: ['surjo', '', '', '', '', ''],
        'present subjunctive': [
            'surja',
            'surjas',
            'surja',
            'surjamos',
            'surjáis',
            'surjan',
        ]
    },
    {
        i: 'nascer',
        present: ['nazco', '', '', '', '', ''],
        'present subjunctive': [
            'nazca',
            'nazcas',
            'nazca',
            'nazcamos',
            'nazcáis',
            'nazcan',
        ]
    },
    {
        i: 'producir',
        present: ['produzco', '', '', '', '', ''],
        'present subjunctive': [
            'produzca',
            'produzcas',
            'produzca',
            'produzcamos',
            'produzcáis',
            'produzcan',
        ]
    },
    {
        i: 'conducir',
        present: ['conduzco', '', '', '', '', ''],
        preterite: [
            'conduje',
            'condujiste',
            'condujo',
            'condujimos',
            'condujisteis',
            'condujeron',
        ],        
        'present subjunctive': [
            'conduzca',
            'conduzcas',
            'conduzca',
            'conduzcamos',
            'conduzcáis',
            'conduzcan',
        ],
        'imperfect subjunctive': [
            'condujera',
            'condujeras',
            'condujera',
            'condujéramos',
            'condujerais',
            'condujeran',
        ]
    },
    {
        i: 'servir',
        present: ['sirvo', 'sirves', 'sirve', '', '', 'sirven'],
        'present subjunctive': [
            'sirva',
            'sirvas',
            'sirva',
            'sirvamos',
            'sirvais',
            'sirvan',
        ]
    },
    {
        i: 'juzgar',
        preterite: ['juzgué', '', '', '', '', ''],
        'present subjunctive': [
            'juzgue',
            'juzgues',
            'juzgue',
            'juzguemos',
            'juzguéis',
            'juzguen',
        ]
    },
];

// remove alternative endings:  \/ [a-zé]*